import React from "react";

const BaseIcon = ({
  children,
  size = 16,
  width,
  height,
  color = "#575756",
  className = "",
  ...props
}) => {
  const iconWidth = width || size;
  const iconHeight = height || size;

  return (
    <svg
      width={iconWidth}
      height={iconHeight}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      {React.cloneElement(children, { stroke: color })}
    </svg>
  );
};

const ArrowIcon = ({
  size = 16,
  color = "#575756",
  className = "",
  ...props
}) => (
  <BaseIcon
    size={size}
    color={color}
    className={className}
    viewBox="0 0 10 5"
    {...props}
  >
    <path
      d="M1.49902 0.75L4.99902 4.25L8.49902 0.75"
      strokeWidth="1.16667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </BaseIcon>
);

const ChevronDownIcon = ({
  size = 16,
  color = "#575756",
  className = "",
  ...props
}) => (
  <BaseIcon
    size={size}
    color={color}
    className={className}
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      d="m6 9 6 6 6-6"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </BaseIcon>
);

const ChevronUpIcon = ({
  size = 16,
  color = "#575756",
  className = "",
  ...props
}) => (
  <BaseIcon
    size={size}
    color={color}
    className={className}
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      d="m18 15-6-6-6 6"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </BaseIcon>
);

const PlusIcon = ({
  size = 16,
  color = "#575756",
  className = "",
  ...props
}) => (
  <BaseIcon
    size={size}
    color={color}
    className={className}
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      d="M12 5v14m-7-7h14"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </BaseIcon>
);

const CloseIcon = ({
  size = 16,
  color = "#575756",
  className = "",
  ...props
}) => (
  <BaseIcon
    size={size}
    color={color}
    className={className}
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      d="M18 6 6 18M6 6l12 12"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </BaseIcon>
);

const BasicIcons = {
  Arrow: ArrowIcon,
  ChevronDown: ChevronDownIcon,
  ChevronUp: ChevronUpIcon,
  Plus: PlusIcon,
  Close: CloseIcon,
};

export default BasicIcons;
